var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.h5ConfigDetails)?_c('div',{staticClass:"status-bar",style:(`height:${_vm.statusBarHeight}${_vm.isInIos ? 'px' : 'vh'};background: ${_vm.h5ConfigDetails[0]['fontColor']['navBg'][0]};`)}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }